// The checkout is opened with these query params, so it can track where the customer came from
export const CHECKOUT_SOURCE_PAGE_QUERY = "src_page";
export const CHECKOUT_SOURCE_ELEMENT_QUERY = "src_element";
